import {makeReactContext} from 'lib/makeReactContext';
import {
  FlowchartNode,
  TaskSchemaNode,
} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';

export interface NodesContextValue {
  nodes: Array<FlowchartNode>;
  startNode: TaskSchemaNode | null;
  endNode: TaskSchemaNode | null;
}

/** Context to provide the full set of nodes along with the start and end node */
export const NodesContext = makeReactContext<NodesContextValue>(
  () => ({
    nodes: [],
    startNode: null,
    endNode: null,
  }),
  'NodesContext'
);
